import type { FC, SVGProps } from "react";

const CardNotPresentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<title>Card Not Present Icon</title>
		<rect x="1" y="3" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" />
		<line x1="1" y1="6.5" x2="15" y2="6.5" stroke="currentColor" strokeWidth="1.5" />
		<line x1="4" y1="9.5" x2="8" y2="9.5" stroke="currentColor" strokeWidth="1.5" />
		<line x1="2" y1="3" x2="14" y2="13" stroke="currentColor" strokeWidth="1.5" />
	</svg>
);

export { CardNotPresentIcon };
